import { makeStyles } from '@mui/styles';

// Dinamik ekranlar ve yetkilendirme sayfalarının ortak tasarım dili
export const ORANGE = '#FF9800';
export const DARK = '#424242';

export const darkButtonSx = {
  color: ORANGE,
  backgroundColor: DARK,
  borderRadius: '10px',
  fontWeight: 600,
  fontSize: '13px',
  height: '36px',
  textTransform: 'none',
  '&:hover': { backgroundColor: '#212121' },
  '&.Mui-disabled': { backgroundColor: '#e0e0e0', color: '#9e9e9e' }
};

export const lightButtonSx = {
  color: DARK,
  borderRadius: '10px',
  fontWeight: 600,
  fontSize: '13px',
  textTransform: 'none'
};

export const inputSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff', fontSize: '13px' },
  '& .MuiInputLabel-root': { fontSize: '13px' },
  '& .MuiInputLabel-root.Mui-focused': { color: ORANGE },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ORANGE }
};

export const listboxProps = { sx: { fontSize: '13px' } };

export const dialogPaperProps = { sx: { borderRadius: '16px' } };

export const useDynamicStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: DARK,
    padding: '10px 16px',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px',
      textTransform: 'uppercase'
    },
    '& .MuiCardHeader-subheader': {
      fontSize: '11px',
      color: '#757575'
    },
    '& .MuiCardHeader-action': {
      margin: 0,
      alignSelf: 'center'
    }
  },
  dialogTitle: {
    backgroundColor: '#f5f5f5',
    color: DARK,
    padding: '12px 16px',
    borderBottom: '1px solid #e0e0e0',
    fontSize: '13px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dialogSection: {
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#fafafa'
  },
  sectionLabel: {
    fontSize: '10px',
    fontWeight: '700',
    color: '#78909c',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '6px'
  },
  // MUI Table için
  table: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      color: DARK,
      fontWeight: '700',
      fontSize: '11px',
      letterSpacing: '0.3px',
      textTransform: 'uppercase',
      borderBottom: '1px solid #e0e0e0',
      padding: '10px 16px'
    },
    '& .MuiTableCell-body': {
      fontSize: '12px',
      color: '#263238',
      padding: '6px 16px',
      borderBottom: '1px solid #f0f0f0'
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      backgroundColor: '#fff8e1'
    }
  },
  // MUI DataGrid için
  grid: {
    border: 'none',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #e0e0e0'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: '700',
      fontSize: '11px',
      color: DARK
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#fff8e1'
    },
    '& .MuiDataGrid-cell': {
      fontSize: '12px',
      color: '#263238'
    },
    '& .MuiDataGrid-footerContainer, & .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select': {
      fontSize: '12px'
    }
  },
  emptyState: {
    padding: '32px 16px',
    textAlign: 'center',
    color: '#90a4ae',
    fontSize: '12px'
  },
  toggleGroup: {
    width: '100%',
    backgroundColor: '#fff',
    '& .MuiToggleButton-root': {
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      padding: '6px 8px',
      color: '#546e7a',
      borderColor: '#e0e0e0',
      '&:first-of-type': { borderRadius: '10px 0 0 10px' },
      '&:last-of-type': { borderRadius: '0 10px 10px 0' }
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: DARK,
      color: ORANGE,
      '&:hover': { backgroundColor: '#212121' }
    }
  }
}));

// Aktif / Pasif durum etiketi
export const statusChipSx = (active) => ({
  height: '22px',
  fontSize: '11px',
  fontWeight: 600,
  borderRadius: '6px',
  backgroundColor: active ? '#e8f5e9' : '#ffebee',
  color: active ? '#2e7d32' : '#c62828'
});
